// El plan que alguien eligió antes de tener que loguearse.
//
// Vive junto al destino post-login (`$lib/auth/destinoPostLogin`) y por el mismo
// motivo: estaba en sessionStorage, que vive por pestaña, y en el celular el
// recorrido cambia de pestaña en el medio (el mail abre el navegador chico de
// Gmail y el login con Google salta al grande). Ahí se perdía, y la persona
// volvía a /planes teniendo que elegir de nuevo lo que ya había elegido.
//
// Mismo vencimiento que el destino: sirve para la compra que está pasando ahora.

const CLAVE = "planPendiente";
const VIGENCIA_MS = 15 * 60 * 1000;

/** Recuerda qué plan estaba por contratar. */
export function guardarPlanPendiente(planId) {
    const id = Number(planId);
    if (!Number.isFinite(id)) return;
    try {
        localStorage.setItem(CLAVE, JSON.stringify({ planId: id, ts: Date.now() }));
    } catch {
        // Storage bloqueado: se pierde el atajo, no la compra. El cartel de
        // "Continuar" de /planes sigue siendo la red.
    }
}

/**
 * El plan guardado, o `null` si no hay o si venció. NO lo consume: la página lo
 * lee para mostrar el cartel y recién lo borra cuando el checkout arranca de
 * verdad.
 */
export function leerPlanPendiente() {
    let crudo = null;
    try {
        crudo = localStorage.getItem(CLAVE);
    } catch {
        return null;
    }
    try {
        const dato = crudo ? JSON.parse(crudo) : null;
        if (dato && Date.now() - dato.ts < VIGENCIA_MS) return dato.planId;
    } catch {
        // Formato viejo (el id pelado en sessionStorage): se descarta.
    }
    return null;
}

/** Se llama cuando el checkout ya arrancó: el plan dejó de estar pendiente. */
export function olvidarPlanPendiente() {
    try {
        localStorage.removeItem(CLAVE);
    } catch {
        // Nada que hacer: vence solo.
    }
}
